import { Component, OnInit } from '@angular/core';
import { AddNewProductService } from '../services/add-new-product.service';

@Component({
  selector: 'cintas-add-new-product',
  templateUrl: './add-new-product.component.html',
  styleUrls: ['./add-new-product.component.scss']
})
export class AddNewProductComponent implements OnInit {

  ngOnInit(): void {
      
  }
  constructor(private AddNewProductService: AddNewProductService) {}

  onSubmit(customerData: any): void {
    // event.preventDefault();
    this.AddNewProductService.addProduct(customerData).subscribe(
      (response) => {
        // console.log('Product added successfully', response);
        alert('Product type added successfully');
        window.location.reload();
      },
      (error) => {
        // console.error('Please Try Again! Error adding Product', error);
        alert('Please Try Again! Error adding Product Type'+ error);
        window.location.reload();
      }
    );
  }
}

